import { useState } from "react";
import { Link } from "react-router-dom";
import SLIDE1 from "../../assets/retailnew.png";
const checkIcon = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    style={{ display: "inline", marginRight: "8px", flexShrink: 0 }}
  >
    <circle cx="8" cy="8" r="8" fill="#10b981" opacity="0.15" />
    <path
      d="M4.5 8.5l2.5 2.5 4.5-5"
      stroke="#10b981"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const features = [
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#fff7ed" />
        <rect x="14" y="18" width="18" height="22" rx="2" fill="#fb923c" />
        <rect x="16" y="14" width="14" height="6" rx="1" fill="#fdba74" />
        <rect
          x="26"
          y="20"
          width="14"
          height="20"
          rx="2"
          fill="#f97316"
          opacity="0.7"
        />
        <path
          d="M18 24h10M18 28h8M18 32h6"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    title: "Billing & POS",
    items: [
      "Fast GST Billing",
      "Barcode Scanning",
      "Discount & Schemes",
      "Multi-payment Modes",
    ],
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#eff6ff" />
        <rect x="12" y="28" width="8" height="16" rx="2" fill="#3b82f6" />
        <rect x="24" y="22" width="8" height="22" rx="2" fill="#60a5fa" />
        <rect x="36" y="16" width="8" height="28" rx="2" fill="#93c5fd" />
        <path
          d="M10 38 L20 32 L30 26 L40 20"
          stroke="#1d4ed8"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="20" cy="32" r="2" fill="#1d4ed8" />
        <circle cx="30" cy="26" r="2" fill="#1d4ed8" />
        <circle cx="40" cy="20" r="2" fill="#1d4ed8" />
      </svg>
    ),
    title: "Inventory Management",
    items: [
      "Real-time Stock Update",
      "Multi-store Transfer",
      "Auto Reorder",
      "Batch Tracking",
    ],
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#f0fdf4" />
        <circle cx="22" cy="28" r="10" fill="#86efac" />
        <circle cx="22" cy="28" r="6" fill="#22c55e" />
        <path
          d="M34 20 L44 20 M34 24 L42 24 M34 28 L40 28"
          stroke="#15803d"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <path
          d="M18 26 L21 29 L26 24"
          stroke="white"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    ),
    title: "Purchase & Vendor",
    items: ["Purchase Tracking", "Vendor Ledger", "Margin Calculation"],
  },
];

const features2 = [
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
        <rect width="44" height="44" rx="10" fill="#fff7ed" />
        <rect x="10" y="14" width="14" height="16" rx="2" fill="#fb923c" />
        <rect x="12" y="10" width="10" height="5" rx="1" fill="#fdba74" />
        <rect
          x="20"
          y="16"
          width="14"
          height="14"
          rx="2"
          fill="#f97316"
          opacity="0.7"
        />
      </svg>
    ),
    title: "Customer Management",
    items: ["Loyality Management", "Credit Customers", "Purchase History"],
  },
  {
    icon: (
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
        <rect width="56" height="56" rx="14" fill="#fefce8" />
        <rect x="12" y="20" width="32" height="22" rx="3" fill="#fde68a" />
        <rect x="12" y="20" width="32" height="8" rx="3" fill="#f59e0b" />
        <rect x="16" y="32" width="10" height="6" rx="1" fill="#f59e0b" />
        <rect x="30" y="32" width="10" height="6" rx="1" fill="#f59e0b" />
        <circle cx="38" cy="16" r="5" fill="#ef4444" />
        <path
          d="M36 16h4M38 14v4"
          stroke="white"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    title: "Accounts Integration",
    items: ["Auto Accounting Entries", "GST Reports", "Profit Reports"],
  },
  {
    icon: (
      <svg width="44" height="44" viewBox="0 0 44 44" fill="none">
        <rect width="44" height="44" rx="10" fill="#f0fdf4" />
        <circle cx="18" cy="22" r="8" fill="#86efac" />
        <circle cx="18" cy="22" r="5" fill="#22c55e" />
        <path
          d="M26 16 L36 16 M26 20 L34 20 M26 24 L32 24"
          stroke="#15803d"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    ),
    title: "Sales & Dispatch",
    items: [
      "Sales Supplier",
      "Dispatch Planning",
      "Delivery Tracking",
      "Customer Order Status",
    ],
  },
];

export default function RetailERP() {
  const [hovered, setHovered] = useState(null);

  return (
    <div
      style={{
        fontFamily: "'Segoe UI', system-ui, sans-serif",
        background: "#fff",
        minHeight: "100vh",
      }}
    >
      {/* NAVBAR */}
      <nav
        style={{
          background: "#fff",
          borderBottom: "1px solid #e5e7eb",
          padding: "0 40px",
          height: "64px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          position: "sticky",
          top: 0,
          zIndex: 100,
          boxShadow: "0 1px 6px rgba(0,0,0,0.06)",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
          <div
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #1e3c72, #2a5298)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="8" stroke="white" strokeWidth="1.5" />
              <path
                d="M6 10 h8 M10 6 v8"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
          <span
            style={{ fontWeight: "700", fontSize: "17px", color: "#1a2847" }}
          >
            AccessInfotech
          </span>
        </div>
        <div style={{ display: "flex", gap: "32px", alignItems: "center" }}>
          {["Home", "Modules ▾", "Solutions ▾", "About +", "Blog ▾"].map(
            (item) => (
              <a
                key={item}
                href="#"
                style={{
                  color: "#374151",
                  textDecoration: "none",
                  fontSize: "14px",
                  fontWeight: "500",
                }}
              >
                {item}
              </a>
            ),
          )}
          <button
            style={{
              background: "#10b981",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              padding: "9px 22px",
              fontWeight: "600",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            Request
          </button>
        </div>
      </nav>
      <section
        style={{
          position: "relative",
          minHeight: "500px",
          backgroundImage: `url(${SLIDE1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* Dark Overlay (for better text visibility) */}
        <div
          style={{
            position: "absolute",
            inset: 0,
          }}
        />

        <div
          style={{
            position: "relative",
            zIndex: 2,
            maxWidth: "1300px",
            margin: "0 auto",
            padding: "60px 50px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
            gap: "40px",
          }}
        >
          <div style={{ maxWidth: "500px" }}>
            <h1
              style={{
                fontSize: "42px",
                fontWeight: "800",
                color: "#fff",
                lineHeight: "1.2",
                margin: "0 0 20px",
              }}
            >
              Complete Retail ERP
              <br />
              <span style={{ fontWeight: "400" }}>
                for Smart Business Management
              </span>
            </h1>

            <p
              style={{
                fontSize: "17px",
                color: "rgba(255,255,255,0.85)",
                lineHeight: "1.7",
                marginBottom: "32px",
                maxWidth: "520px", // control wrapping
                textAlign: "left", // force left alignment
              }}
            >
              Manage billing, inventory, customers, earnings, and accounting for
              smooth operations for multiple stores.
            </p>

            <Link to="/contact" style={{ textDecoration: "none" }}>
              <button
                style={{
                  background: "#10b981",
                  color: "#fff",
                  border: "none",
                  borderRadius: "8px",
                  padding: "14px 36px",
                  fontWeight: "700",
                  fontSize: "16px",
                  cursor: "pointer",
                  boxShadow: "0 4px 20px rgba(16,185,129,0.4)",
                }}
              >
                Request Demo
              </button>
            </Link>
          </div>
        </div>
      </section>

      {/* KEY FEATURES - Section 1 (4 columns) */}
      <section
        style={{
          background: "linear-gradient(180deg, #e8f1ff 0%, #dce9ff 100%)",
          padding: "60px 50px",
        }}
      >
        <div style={{ maxWidth: "1300px", margin: "0 auto" }}>
          <h2
            style={{
              textAlign: "center",
              fontSize: "38px",
              fontWeight: "800",
              color: "#1a2847",
              marginBottom: "48px",
            }}
          >
            Key Features
          </h2>

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "24px",
              marginBottom: "64px",
            }}
          >
            {features.map((f, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "32px 24px",
                  boxShadow: "0 4px 24px rgba(30,60,114,0.08)",
                  transition: "transform 0.2s, box-shadow 0.2s",
                  transform: hovered === i ? "translateY(-4px)" : "none",
                  cursor: "default",
                }}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
              >
                <div style={{ marginBottom: "16px" }}>{f.icon}</div>
                <h3
                  style={{
                    fontSize: "17px",
                    fontWeight: "700",
                    color: "#1a2847",
                    marginBottom: "16px",
                  }}
                >
                  {f.title}
                </h3>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {f.items.map((item, j) => (
                    <li
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "#475569",
                        marginBottom: "8px",
                      }}
                    >
                      {checkIcon}
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* KEY FEATURES - Section 2 (3 columns) */}
          {/* <h2
            style={{
              textAlign: "center",
              fontSize: "38px",
              fontWeight: "800",
              color: "#1a2847",
              marginBottom: "48px",
            }}
          >
            Key Features
          </h2> */}

          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "28px",
              marginBottom: "48px",
            }}
          >
            {features2.map((f, i) => (
              <div
                key={i}
                style={{
                  background: "#fff",
                  borderRadius: "16px",
                  padding: "36px 28px",
                  boxShadow: "0 4px 24px rgba(30,60,114,0.08)",
                  transition: "transform 0.2s",
                  transform: hovered === `b${i}` ? "translateY(-4px)" : "none",
                }}
                onMouseEnter={() => setHovered(`b${i}`)}
                onMouseLeave={() => setHovered(null)}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "14px",
                    marginBottom: "20px",
                  }}
                >
                  {f.icon}
                  <h3
                    style={{
                      fontSize: "18px",
                      fontWeight: "700",
                      color: "#1a2847",
                      margin: 0,
                    }}
                  >
                    {f.title}
                  </h3>
                </div>
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {f.items.map((item, j) => (
                    <li
                      key={j}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        fontSize: "15px",
                        color: "#475569",
                        marginBottom: "10px",
                      }}
                    >
                      {checkIcon}
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* CTA Button */}
          {/* <div style={{ textAlign: "center" }}>
            <button style={{
              background: "linear-gradient(135deg, #1e3c72, #2a5298)",
              color: "#fff",
              border: "none",
              borderRadius: "12px",
              padding: "18px 64px",
              fontSize: "18px",
              fontWeight: "700",
              cursor: "pointer",
              boxShadow: "0 8px 30px rgba(30,60,114,0.3)",
              letterSpacing: "0.3px",
            }}>
              Request Retail ERP Demo
            </button>
          </div> */}
        </div>
      </section>
    </div>
  );
}
